const DESIGN_SYSTEM_TAG = 'v0.581.1'
const DESIGN_SYSTEM_BASE_URL = `https://cdn.jsdelivr.net/gh/ahaslides-product/ahaslides-design@${DESIGN_SYSTEM_TAG}/lib`

let audienceDesignSystemPromise = null

const appendTokens = () => {
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = `${DESIGN_SYSTEM_BASE_URL}/tokens.css`
  document.head.appendChild(link)
}

const appendAudienceScript = () => new Promise((resolve, reject) => {
  const script = document.createElement('script')
  script.type = 'module'
  script.src = `${DESIGN_SYSTEM_BASE_URL}/audience.js`
  script.onload = resolve
  script.onerror = () => reject(new Error(`design system ${DESIGN_SYSTEM_TAG} audience bundle failed to load`))
  document.head.appendChild(script)
})

// Loaded on first use, never at boot: the audience join path must not fetch it (.claude/rules/hot-paths.md).
export const loadAudienceDesignSystem = () => {
  if (!audienceDesignSystemPromise) {
    appendTokens()
    audienceDesignSystemPromise = appendAudienceScript()
      .then(() => window.customElements.whenDefined('aha-audience-modal'))
      .catch((error) => {
        audienceDesignSystemPromise = null
        throw error
      })
  }
  return audienceDesignSystemPromise
}

export const designSystemLogoUrl = (fileName) => `${DESIGN_SYSTEM_BASE_URL.replace(/\/lib$/, '')}/logo/${fileName}`

export default loadAudienceDesignSystem
